/* src/app/modules/expense-reports/components/reports-payment/generate-layout-payments/generate-layout-payments.component.scss */
/*# sourceMappingURL=generate-layout-payments.component.css.map */
